<div class="r2icon-close" (click)="close()">
  <i class="fas fa-times-circle"></i>
</div>

@if (isArray) {
  <ngb-carousel
    [activeId]="activeId"
    [showNavigationArrows]="data.length > 1"
    [showNavigationIndicators]="data.length > 1"
  >
    @for (photo of data; track photo) {
      <ng-template ngbSlide [id]="photo.id">
        <div class="photo">
          <img [src]="photo.imageUrl" alt="Preview Image" />
        </div>
      </ng-template>
    }
  </ngb-carousel>
}

@if (data.imageUrl) {
  <img [src]="data.imageUrl" alt="Preview Image" />
}
@if (data.mp4Url) {
  <video [src]="data.mp4Url | trustSrc" controls></video>
}
